import { trackAction } from "./../utils/mrTracker"

export default () => next => action => {
    trackAction(action);
    return next(action);
}